<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">add_circle</v-icon>
            Add tags
          </span>
        </v-card-title>
        <v-card-text>
          <v-form ref="add_tags" data-vv-scope="add_tags" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea
                  v-model="tags"
                  label="tags*"
                  hint="Enter tags one per line or separated by commas"
                  v-validate="'required'"
                  data-vv-name="add_tags.tags"
                  :error-messages="errors.collect('add_tags.tags')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveTags()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'AddTagsModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['addTagsDialog', 'projectId', 'keywordIds', 'loading'],
  data () {
    return {
      dialog: this.addTagsDialog,
      tags: '',
      dictionary: {
        en: {
          custom: {
            'add_tags.tags': {
              required: 'Please add tags'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    addTagsDialog: {
      handler () {
        console.log(this.keywordIds)
        this.dialog = this.addTagsDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('addTagsDialog', this.dialog)
      }
    }
  },
  methods: {
    saveTags () {
      this.$validator.validateAll('add_tags').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)

          let params = {
            projectId: this.projectId,
            keywordIds: this.keywordIds,
            tags: this.tagsToArray(this.tags)
          }

          this.$store.dispatch('ADD_TAGS', params).then(res => {
            this.$toasted.show('Tags was successfully added to selected keywords')
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateKeywords')
            this.closeModal()
          }, err => {
            console.log('login error', err)
            this.$parent.$emit('loading', false)
            this.$toasted.show('ADD_TAGS ERROR: ' + this.$services.getApiError(err), { type: 'error' })
          })
        }
      })
    },
    tagsToArray (strTags) {
      let arrTags = []

      // check if there are some lines
      var match = /\r|\n/.exec(strTags)

      if (match) {
        let arrLines = strTags.match(/[^\r\n]+/g)
        arrTags = arrLines.map((line) => {
          return line.split(',').map((tag) => { return tag.trim() })
        })
        // join arrays in array
        arrTags = [].concat.apply([], arrTags)
      } else {
        arrTags = strTags.split(',').map((tag) => { return tag.trim() })
      }

      // remove empty values
      arrTags = arrTags.filter((tag) => {
        return tag != null && tag !== ''
      })

      // convert to format with period
      // arrTags = arrTags.map((tag) => { return [tag, 1] })

      return arrTags
    },
    closeModal () {
      this.dialog = false
      setTimeout(() => {
        this.$validator.errors.clear('add_tags')
      }, 500)
    },
    formToProject () {
      this.project.id = this.projectData.id
      this.project.name = this.form.name
      this.project.domain = this.form.domain
      this.project.subdomains = this.form.subdomains.split(',').map((subdomain) => { return subdomain.trim() }).filter(subdomain => subdomain)
    },
    clearForm () {
      this.form = {
        name: '',
        domain: '',
        verify: true,
        subdomains: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/add-tags-modal/AddTagsModal.vue